// extracted by mini-css-extract-plugin
export default {"loading_text":"loading_loading_text__T0otp"};